<template>
  <div class=" justify-center px-6 py-12 lg:px-8 p-3">
    <slot/>

    <Toaster />
  </div>
</template>